import { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setAppFileContent } from '../../../../../slices/docsSlices';

export const useRealTimeUpdate = (filePath, content, onUpdate) => {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);
  const lastContentRef = useRef('');

  const debouncedUpdate = useCallback((newContent) => {
    // Limpiar el timeout anterior
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Solo actualizar si el contenido realmente cambió
    if (newContent !== lastContentRef.current) {
      lastContentRef.current = newContent;
      
      // Actualizar Redux inmediatamente para tiempo real
      dispatch(setAppFileContent({ path: filePath, content: newContent }));
      
      // Llamar al callback de actualización con debounce
      timeoutRef.current = setTimeout(() => {
        if (onUpdate) {
          onUpdate(newContent);
        }
      }, 1000); // 1 segundo de debounce para el backend
    }
  }, [filePath, dispatch, onUpdate]);

  // Efecto para actualizar cuando cambie el contenido
  useEffect(() => {
    if (content !== undefined && filePath) {
      debouncedUpdate(content);
    }
  }, [content, filePath]); // Removido debouncedUpdate de las dependencias

  // Limpiar timeout al desmontar
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debouncedUpdate;
}; 